import { useEffect, useState } from 'react'

import {
  SIDEBAR_NAV_MODE_CHANGE_EVENT,
  readStoredSidebarNavMode,
  setSidebarNavMode
} from './sidebarNavMode'

export default function useSidebarNavMode() {
  const [navMode, setNavMode] = useState(readStoredSidebarNavMode)

  useEffect(() => {
    function handleNavModeChange(event) {
      setNavMode(event.detail || readStoredSidebarNavMode())
    }

    window.addEventListener(SIDEBAR_NAV_MODE_CHANGE_EVENT, handleNavModeChange)
    return () => {
      window.removeEventListener(SIDEBAR_NAV_MODE_CHANGE_EVENT, handleNavModeChange)
    }
  }, [])

  return [navMode, setSidebarNavMode]
}
